module.exports = __webpack_public_path__ + "static/media/logo-hackernews.c92a375d.svg";